import { defineComponent, computed, onMounted, ref } from "vue";
import { useMaintenanceScheduleStore } from "../maintenanceScheduleStore";
export default defineComponent({
    name: "MaintenanceScheduleModel",
    setup() {
        const questionBlock = ref(null);
        const hiddenAttribute = "aria-hidden";
        const inertAttribute = "inert";
        const store = useMaintenanceScheduleStore();
        const questionModelAnswers = computed(() => {
            return store.questionModelAnswers;
        });
        const fieldIsDisabled = computed(() => {
            const inertValue = questionBlock.value?.getAttribute(inertAttribute);
            return (questionBlock.value?.getAttribute(hiddenAttribute) === "true" ||
                inertValue === "" ||
                inertValue === "true");
        });
        function answered(event, modelName, modelPhotoUrl) {
            if (fieldIsDisabled.value) {
                event.preventDefault();
                return;
            }
            store.updateQuestionModelAnswer(modelName, modelPhotoUrl);
            const selectedModel = event.currentTarget;
            updateSelectedModel(selectedModel);
        }
        function updateSelectedModel(selectedModelElement) {
            const models = document.querySelectorAll(".model");
            models.forEach((model) => {
                if (model !== selectedModelElement) {
                    model.setAttribute("aria-checked", "false");
                }
            });
            selectedModelElement.setAttribute("aria-checked", "true");
        }
        onMounted(() => {
            questionBlock.value = document.getElementById("maintenanceScheduleQuestionTwo");
        });
        return {
            questionModelAnswers,
            answered,
            fieldIsDisabled,
        };
    },
});
